import { makeSizeTokens } from '@utils/react/selectors';

const hintsSize = makeSizeTokens("--hint-size", {
  height: "0px",
  width: "0px"
});
const splitWrapper = "_35ssl5qi7d";
const introductionWrapper = "_35siwgdrcc";
const stickyIntroduction = "_35ss1cx407j";
const contentWrapper = "_35sc1ea6dwc";
const content = "_35sc11uuwuk";
const stickyContent = "_35sskgjker";

export { content, contentWrapper, hintsSize, introductionWrapper, splitWrapper, stickyContent, stickyIntroduction };
import "./container.split-view.style.linaria.module.css";
//# sourceMappingURL=container.split-view.style.js.map
